// extracted by mini-css-extract-plugin
export default {"button":"S[ecImageDialog_button__EBX4i"};